/**
 * @generated SignedSource<<8fc86281b0fc74cf5f33ac05bdf7f7aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditAccommodation_package$data = {
  readonly hotel: {
    readonly id: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"AssignHotelToPackageDialog_package" | "PackageEditAccomodationHotel_package" | "PackageEditAccomodationPrices_package">;
  readonly " $fragmentType": "PackageEditAccommodation_package";
};
export type PackageEditAccommodation_package$key = {
  readonly " $data"?: PackageEditAccommodation_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditAccommodation_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditAccommodation_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Hotel",
      "kind": "LinkedField",
      "name": "hotel",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditAccomodationHotel_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditAccomodationPrices_package"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AssignHotelToPackageDialog_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "bdb390d029d5b929967dd6229564af6b";

export default node;
